export default __webpack_public_path__ + "static/media/Sarah.ac4ba33c.jpg";